module.exports = "https://cdn.thelire.com/ins/resource/lh_special_one_follower@3x.6da9980558cbcaac2fbdab06013fe62a.png";